$(() => {
  if (!$('[data-toggle="tooltip"]').length) {
    return
  }
  $('[data-toggle="tooltip"]').tooltip()
})
